export const usePieChart = () => {
  const setupPieChart = (element: HTMLElement, value: number, max: number): void => {
    const percent = Math.min(100, Math.max(0, (value / max) * 100)).toFixed(1);
    const label = element.querySelector(".pie-chart__value") as HTMLElement;

    if (element) {
      element.style.setProperty("--pie-chart-value", percent.toString());
    }
    
    if (label) {
      label.textContent = value.toString();
    }
  };

  return {
    setupPieChart
  };
}